export const BRAND_CODE_MAP = {
  C: 'Chevrolet',
  G: 'GMC',
  B: 'Buick',
  K: 'Cadillac',
};

export const normalizeSelectionBrands = (value) => {
  if (!value) {
    return { codes: [], display: '' };
  }

const toCodes = (input) => {
  if (typeof input === 'string') {
    const trimmed = input.trim();
    if (!trimmed) return [];
    if (trimmed.includes(',')) {
      return trimmed
        .split(',')
        .map((token) => token.trim())
        .filter(Boolean)
        .flatMap((token) => toCodes(token));
    }
    const normalized = trimmed.toUpperCase();
    if (normalized === 'CAD') return ['K'];
    if (/^[CGBK]+$/.test(normalized)) {
      return normalized.split('');
    }
    return [trimmed];
  }
  if (Array.isArray(input)) {
    return input.flatMap((entry) => toCodes(entry));
  }
    if (typeof input === 'object') {
      const candidates = ['code', 'brandCode', 'brandCd', 'brand', 'brands'];
      for (const key of candidates) {
        if (input[key]) return toCodes(input[key]);
      }
    }
    return [];
  };

  const codes = toCodes(value)
    .map((code) => String(code).trim())
    .filter(Boolean);

  const uniqueCodes = Array.from(new Set(codes));
  const names = uniqueCodes.map((code) => BRAND_CODE_MAP[code] || code);

  return {
    codes: uniqueCodes,
    display: names.join(', '),
  };
};
